export const DEFAULT_LOAD = {
  pick_city: "",
  delivery_city: "",
  loaded_miles: "",
  empty_miles: "",
  pickup_time: "",
  delivery_time: "",
  weight: "",
  commodity: "",
  rate: "",
  cost_per_mile: 1.6,
  driver_pay_per_mile: 0.65,
  dispatcher_fee_pct: 10,
  min_profit_goal: 300,
};

const NUMERIC_FIELDS = [
  "loaded_miles", "empty_miles", "weight", "rate",
  "cost_per_mile", "driver_pay_per_mile", "dispatcher_fee_pct", "min_profit_goal",
];

export function toLoadPayload(load) {
  const payload = { ...load };
  NUMERIC_FIELDS.forEach((k) => { payload[k] = Number(payload[k]) || 0; });
  return payload;
}

export function computeMetrics(data) {
  const loaded = Number(data.loaded_miles) || 0;
  const empty = Number(data.empty_miles) || 0;
  const rate = Number(data.rate) || 0;
  const cpm = Number(data.cost_per_mile) || 0;
  const dpm = Number(data.driver_pay_per_mile) || 0;
  const feePct = Number(data.dispatcher_fee_pct) || 0;
  const goal = Number(data.min_profit_goal) || 0;

  const total_miles = loaded + empty;
  const real_rpm = total_miles > 0 ? rate / total_miles : 0;
  const trip_cost = total_miles * cpm;
  const driver_pay = total_miles * dpm;
  const dispatcher_fee = rate * (feePct / 100);
  const net_profit = rate - (trip_cost + driver_pay + dispatcher_fee);
  const profit_per_mile = total_miles > 0 ? net_profit / total_miles : 0;
  const is_profitable = net_profit >= goal;

  return {
    total_miles,
    real_rpm,
    trip_cost,
    driver_pay,
    dispatcher_fee,
    net_profit,
    profit_per_mile,
    is_profitable,
  };
}

export const fmtMoney = (v) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(Number(v) || 0);

export const fmtNumber = (v, digits = 0) =>
  new Intl.NumberFormat("en-US", {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(Number(v) || 0);

export const fmtRPM = (v) => `$${(Number(v) || 0).toFixed(3)}`;
